import { render, staticRenderFns } from "./ProfitInvoice.vue?vue&type=template&id=68d897e0&scoped=true&"
import script from "./ProfitInvoice.vue?vue&type=script&lang=js&"
export * from "./ProfitInvoice.vue?vue&type=script&lang=js&"
import style0 from "./ProfitInvoice.vue?vue&type=style&index=0&id=68d897e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d897e0",
  null
  
)

export default component.exports